import { nextRandom } from './rng';
import type { DiceOffResult, D6Value } from '../types/protocol';

function rollD6(rngState: number): { value: D6Value; rngState: number } {
  const next = nextRandom(rngState);
  const value = (1 + Math.floor(next.value * 6)) as D6Value;
  return { value, rngState: next.state };
}

/**
 * Resolves a first-player die-off from a seedable RNG cursor.
 * Ties re-roll until one side is higher; the higher roll goes first.
 */
export function resolveDiceOff(seed: number): {
  result: DiceOffResult;
  rngState: number;
} {
  let rngState = seed >>> 0 || 1;
  const rounds: [D6Value, D6Value][] = [];
  for (let i = 0; i < 24; i++) {
    const a = rollD6(rngState);
    rngState = a.rngState;
    const b = rollD6(rngState);
    rngState = b.rngState;
    rounds.push([a.value, b.value]);
    if (a.value !== b.value) {
      return {
        result: {
          rounds,
          firstPlayer: a.value > b.value ? 0 : 1,
        },
        rngState,
      };
    }
  }
  return {
    result: { rounds, firstPlayer: 0 },
    rngState,
  };
}

/** 3D throw. */
export const DICE_ROLL_MS = 500;
/** Pause after a tied round, before the next throw. */
export const DICE_TIE_MS = 120;
/** How long the "you go first" card stays up. Tap skips it. */
export const DICE_RESULT_MS = 950;
/** Overlay mount before the first throw. */
export const DICE_MOUNT_BUFFER_MS = 80;

/**
 * How long the client 3D roll + result card should take, in ms.
 */
export function diceAnimationMs(rounds: number): number {
  const n = Math.max(1, rounds);
  return (
    n * DICE_ROLL_MS +
    Math.max(0, n - 1) * DICE_TIE_MS +
    DICE_RESULT_MS +
    DICE_MOUNT_BUFFER_MS
  );
}
